import type { ArealplanDelområde } from '@origo/arealplan';
import type { SeksjonContext } from './types';
import { groupKeyForFeature } from '../planer/utils/geometryUtils';
import { objectTypeAttributesMappings } from '../planer/utils/planUtils';

/**
 * Finn arealplan-delområdene som hører til en navigasjonskontekst — grunnlaget
 * for kartmarkeringen i AdminPage.
 *
 *   • `delomrade`        → det ene delområdet (matchet på omradeId).
 *   • `delomradetype`    → alle delområder med dette arealformålet (f.eks. alle
 *                          «frittliggende småhusbebyggelse»).
 *   • `delomradegruppe`  → unionen av gruppens medlemmer. Medlemskap matches på
 *                          delområde-LOKALID, som er identisk med feature-ens
 *                          omradeId (jf. NavPanel-treet). Medlems-IDene sendes
 *                          inn via `gruppeMembers` fordi gruppe↔medlem-relasjonen
 *                          eies av komponenten, ikke av feature-laget.
 *
 * Øvrige kontekster (plan/kommune/omrade) markeres ikke i kartet og gir tom liste.
 */
export function findFeaturesForContext(
    ctx: SeksjonContext,
    planomrader: ArealplanDelområde[],
    gruppeMembers?: ReadonlySet<string>
): ArealplanDelområde[] {
    if (ctx.type === 'delomrade' && ctx.omradeId) {
        return planomrader.filter((f) => f.omradeId === ctx.omradeId);
    }
    if (ctx.type === 'delomradetype' && ctx.delomradetype) {
        return planomrader.filter(
            (f) => groupKeyForFeature(f, objectTypeAttributesMappings) === ctx.delomradetype
        );
    }
    if (ctx.type === 'delomradegruppe' && gruppeMembers && gruppeMembers.size > 0) {
        return planomrader.filter((f) => f.omradeId != null && gruppeMembers.has(f.omradeId));
    }
    return [];
}
